define.alias("shared/components/shared/suggestion-text-area", "settings/components/shared/suggestion-text-area");